import { getBackendUrl } from '../lib/api';
import React, { useState, useEffect, useRef } from 'react';
import { Building, ChevronDown, Check } from 'lucide-react';

const BrandSelector = ({ selectedBrand, onBrandChange, className = '' }) => {
  const [brands, setBrands] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    fetch(`${getBackendUrl()}/api/brands`)
      .then(r => r.json())
      .then(data => {
        const all = [{ id: null, name: 'Toutes les marques' }, ...(data.brands || [])];
        setBrands(all);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  if (brands.length <= 2) return null; // Only show if there are multiple brands

  const current = brands.find(b => b.id === selectedBrand) || brands[0];

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors text-sm"
        data-testid="brand-selector"
      >
        <Building className="h-4 w-4" />
        <span className="hidden md:inline max-w-[120px] truncate">{current?.name}</span>
        <ChevronDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-200 z-50 py-1" data-testid="brand-dropdown">
          {brands.map((brand) => (
            <button
              key={brand.id || 'all'}
              onClick={() => {
                onBrandChange(brand.id);
                setOpen(false);
              }}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 flex items-center justify-between ${
                selectedBrand === brand.id ? 'text-tp-primary font-medium' : 'text-gray-700'
              }`}
            >
              <span className="flex items-center gap-2">
                {brand.id && (
                  <span 
                    className="w-3 h-3 rounded-full flex-shrink-0" 
                    style={{ backgroundColor: brand.primary_color || '#0F2744' }}
                  />
                )}
                {brand.name}
              </span>
              {selectedBrand === brand.id && <Check className="h-4 w-4 text-tp-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BrandSelector;
